import { API_ROOT } from '../../config/config'
import { doDownload, doGet } from './utils'

export const getDownloadFormSchema = () => {
  const url = `${API_ROOT}/portal/doc`
  return doGet(url)
}

export const downloadFileManual = (fileId) => {
  const url = `${API_ROOT}/portal/doc/download/${fileId}`
  return doDownload(url)
}

export const downloadFileManualPath = (filePath) => {
  const url = `${API_ROOT}/portal/doc/sys-doc?filePath=${filePath}`
  return doDownload(url)
}
